import { autoscan_track_colors } from 'z3k-settings/components/utils/ColorPicker4bit';
export default class GroupColourGenerator {
    request_number;
    constructor() {
        this.request_number = 0;
    }
    get_new_colour() {
        return this.#generate_colour();
    }
    get_current_colour() {
        return this.#current_colour();
    }
    #generate_colour() {
        const colour = autoscan_track_colors[this.request_number % autoscan_track_colors.length];
        this.request_number += 1;
        return colour[0];
    }
    #current_colour() {
        return autoscan_track_colors[this.request_number % autoscan_track_colors.length][0];
    }
}
